import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {RadioFormik, Toggle} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {MFAStatus} from 'types';
import {buildTranslationKey} from 'utils/transform';

import {SECURITY_FIELDS} from '../../settings.constants';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SETTINGS.MFA;

type Props = {
    mfaStatus: MFAStatus;
}

export const MultiFactorAuthentication: React.FC<Props> = ({mfaStatus}) => {
    const {t} = useTranslation();

    const buildOptionName = useCallback((status: MFAStatus): string => {
        const tKey = buildTranslationKey(status);
        return t(T_KEYS.OPTIONS[tKey]);
    }, [t]);

    return (
        <div className='tw-mt-8'>
            <div className='tw-ts-h5'>{t(T_KEYS.TITLE)}</div>
            <div className='tw-flex tw-mt-6 -sm:tw-flex-col'>
                <div className='tw-mr-8 -sm:tw-mb-4'>{t(T_KEYS.STATUS)}</div>
                <RadioFormik
                    className='tw-mr-6 -sm:tw-my-2'
                    name={SECURITY_FIELDS.MFA_STATUS}
                    value={MFAStatus.Disabled}
                    label={buildOptionName(MFAStatus.Disabled)}
                    checked={mfaStatus === MFAStatus.Disabled}
                />
                <RadioFormik
                    className='tw-mr-6 -sm:tw-my-2'
                    name={SECURITY_FIELDS.MFA_STATUS}
                    value={MFAStatus.Optional}
                    label={buildOptionName(MFAStatus.Optional)}
                    checked={mfaStatus === MFAStatus.Optional}
                />
                <RadioFormik
                    className='tw-mr-6 -sm:tw-my-2'
                    name={SECURITY_FIELDS.MFA_STATUS}
                    value={MFAStatus.Required}
                    label={buildOptionName(MFAStatus.Required)}
                    checked={mfaStatus === MFAStatus.Required}
                />
            </div>
            {mfaStatus !== MFAStatus.Disabled &&
                <div className='tw-flex tw-mt-6'>
                    <div className='tw-mr-8'>{t(T_KEYS.GET_BY.LABEL)}</div>
                    <Toggle size='small' label={t(T_KEYS.GET_BY.EMAIL)} checked name={SECURITY_FIELDS.MFA_EMAIL_ENABLED} disabled />
                </div>}
        </div>
    );
};